import React from 'react';
import Inline from './controls/Inline';
import FontFamily from './controls/FontFamily';
import FontSize from './controls/FontSize';
import TextAlign from './controls/TextAlign';
import List from './controls/List';
import Uppercase from './controls/Uppercase';
import FontColor from './controls/FontColor';
import Spacing from './controls/Spacing';
import { useDispatch } from 'react-redux';
import { EditorState, SelectionState } from 'draft-js';
import { designActions } from '../../actions';
import { Button } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import './VEditorToolbar.css';

const VEditorToolbar = props => {
  const { selectedEditorId, ids } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const onChange = editorState => {
    if (ids) dispatch(designActions.changeEditorsState(editorState));
    else dispatch(designActions.changeEditorState({ [selectedEditorId]: editorState }));
  };

  const changeTextInlineStyle = style => {
    if (ids) dispatch(designActions.changeTextEditorsStyle(ids, style));
    else dispatch(designActions.changeTextEditorStyle(selectedEditorId, style));
  };

  const selectAll = editorState => {
    const currentContent = editorState.getCurrentContent();
    const selectionState = SelectionState.createEmpty(currentContent.getFirstBlock().getKey());
    const selection = selectionState.merge({
      anchorKey: currentContent.getFirstBlock().getKey(),
      anchorOffset: 0,
      focusOffset: currentContent.getLastBlock().getText().length,
      focusKey: currentContent.getLastBlock().getKey(),
      hasFocus: true,
    });
    return EditorState.forceSelection(editorState, selection);
  };

  const editMode = () => {
    dispatch(designActions.changeEditableMode({ id: selectedEditorId, editable: true }));
  };

  return (
    <div className="toolbar textToolbar">
      {!ids && <Button onMouseDown={editMode}>{t('edit')}</Button>}
      <TextAlign entityId={selectedEditorId} onChange={changeTextInlineStyle} ids={ids} />
      <Uppercase entityId={selectedEditorId} onChange={changeTextInlineStyle} ids={ids} />
      <List entityId={selectedEditorId} onChange={changeTextInlineStyle} ids={ids} />
      <Inline entityId={selectedEditorId} onChange={changeTextInlineStyle} ids={ids} />
      <FontColor entityId={selectedEditorId} onChange={changeTextInlineStyle} ids={ids} />
      <Spacing entityId={selectedEditorId} onChange={onChange} ids={ids} selectAll={selectAll} />
      <FontSize entityId={selectedEditorId} onChange={changeTextInlineStyle} ids={ids} />
      <FontFamily entityId={selectedEditorId} onChange={changeTextInlineStyle} ids={ids} />
    </div>
  );
};

VEditorToolbar.propTypes = {
  selectedEditorId: PropTypes.number,
  ids: PropTypes.array,
};

export default VEditorToolbar;
